export default {
  init() {
    // JavaScript to be fired on the home page

    if ( $('div').hasClass( 'module-product' ) ) {
      $( '.module-product div.products' ).slick({
        arrows: true,
        infinite: true,
        initialSlide: 3,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 665,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        }],
      });
    }

    var $plus  = $('.plus');
    var $minus = $('.minus');

    $plus.click(function(){
      var $qty   = $('.js-qty');
      var $val   = $qty.val();
      $qty.val( parseInt( $val ) + 1 );
    });

    $minus.click(function(){
      var $qty   = $('.js-qty');
      var $val   = $qty.val();

      if( parseInt( $val ) <= 1 ) {
        $qty.val(1);
      } else {
        $qty.val( parseInt( $val ) - 1 );
      }
    });

    // setPrices();

    // function setPrices(){
    //   var __parent = $('.price');

    //   __parent.each(function(_parent){
    //     var $from = $('del .woocommerce-Price-amount', _parent).text();
    //     var $to = $('ins .woocommerce-Price-amount', _parent).text();
        
    //     console.log( $from );
    //     console.log( $to );
    //     $('del', _parent).text( $from );
    //     $('ins', _parent).text( $to );
    //   });
      
    // }

    $('.tab-controls a').click(function(e){
      e.preventDefault();
      var id = $(this).attr('id');
      $('.tab-controls a').removeClass('is-active');
      $(this).addClass('is-active');

      $('.tab-content-text').removeClass('is-active');
      $('.' + id).addClass('is-active');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js